export default "__VITE_ASSET__Bbej4Sgu__"